// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'font-awesome/css/font-awesome.css'
import '@/assets/iconfonts/iconfont/iconfont.css'
import '@/assets/iconfonts/iconfont2/iconfont.css'
import '@/assets/iconfonts/iconfont3/iconfont.css'
import '@/assets/iconfonts/iconfont4/iconfont.css'
import '@/assets/iconfonts/iconfont5/iconfont.css'
import '@/assets/iconfonts/transfericon/iconfont.css'
import '@/assets/iconfonts/rest/iconfont.css'
import '@/assets/iconfonts/icomoon/style.css'
import Vue from 'vue';
import store from '@/assets/js/vuex.js';
import App from './App'
import router from './router'
import VueWechatTitle from 'vue-wechat-title' //网页标题处理
import Common from "@/assets/common.js";
import './assets/js/validate.js';
import user from "@/assets/js/user.js"; //引入用户
import booking from "@/assets/js/booking.js"; //引入用户
import Mint from 'mint-ui'
// import VueAMap from 'vue-amap';
import 'mint-ui/lib/style.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueBetterScroll from 'vue2-better-scroll'
import '@/filters/filter.js'
import registryPopup from "@/components/popup/index.js";


Vue.use(Mint);
Vue.use(VueBetterScroll);
Vue.use(VueWechatTitle);
// Vue.use(VueAMap);
Vue.use(VueAwesomeSwiper)
Vue.use(registryPopup)
Vue.config.productionTip = false;
// 美团酒店获取地理位置
// VueAMap.initAMapApiLoader({
//   key: 'd8477702ad6de2ff332eddc3138b1d73',
//   plugin: [
//           'AMap.Autocomplete',
// 	        'AMap.PlaceSearch',
// 	        'AMap.Scale',
// 	        'AMap.OverView',
// 	        'AMap.ToolBar',
// 	        'AMap.MapType',
// 	        'AMap.PolyEditor',
// 	        'AMap.CircleEditor',
// 	        'AMap.Geolocation'
//         ],
//   v: '1.4.4'
// });
// Vue.use(InfiniteScroll);
// console.log(Vue.prototype);
//_user为用户对象，在其他组件中，需在vue实例化后，用this._user调用，否则import user后用user调用
Vue.prototype._user = user;
//_booking为预订对象，在其他组件中，需在vue实例化后，用this._user调用，否则import user后用user调用
Vue.prototype._booking = booking;
/* eslint-disable no-new */
Vue.config.ignoredElements = ['wx-open-launch-weapp']
// 国网统计配置
// 全局id
Vue.prototype._gwqId = 'GWD-006031';
router.beforeEach((to, from, next) => {
    // alert('come to beforeeach');
     // 统计代码
    if (to.path) {
    //   _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        // alert('some route');
        //当没有actionType时，验证登录状态(有的时候代表微信登录)
        if (!Common.getUrlQuery("actionType")) {
            // alert('hasnoactiontype');
            //验证登录状态
            if (Common.curPayEnv() != "WeiXinMP") {
               user.checkLogin(to.fullPath, next);     
            } else {
                next();
            }
        } else {
            next();
        }
    } else {
        next()
    }
})
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js